import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import Chatbot from "./components/Chatbot.jsx";
import Home from "./pages/Home.jsx";
import Resume from "./pages/Resume.jsx";
import Projects from "./pages/Projects.jsx";
import ProjectDetails from "./pages/ProjectDetails.jsx";
import Contact from "./pages/Contact.jsx";
import UpiPayment from "./pages/UpiPayment.jsx";
import Blog from "./pages/Blog.jsx";
import Chat from "./pages/Chat.jsx";
import AboutRPX from "./pages/About.jsx";
import Achievements from "./pages/Achievements.jsx";
import "./CSS/App.css";
import { useTranslation } from 'react-i18next';
import './i18n'; // Initialize i18n
import HighlightKeyword from './components/HighlightKeyword.jsx';
import DarkMode from './DarkMode/DarkMode';
import SocialLinks from './pages/SocialLinks.jsx';
import ErrorPage from './components/ErrorPage.jsx';
import Drop from './pages/Drop.jsx';
import DownloadList from './pages/DownloadList.jsx';

const App = () => {
  const { i18n } = useTranslation();

  const [theme, setTheme] = useState("light");
  const [language, setLanguage] = useState("en");
  const [isDark, setIsDark] = useState(false);

  // Apply theme to the root div
  useEffect(() => {
    document.body.classList.toggle("dark-mode", theme === "dark");
  }, [theme]);

  // Apply language on change
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);

  // On component mount, check localStorage for theme preference
  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme === 'dark') {
      setIsDark(true);
      document.body.classList.add('dark-mode');
    }
  }, []);

  const toggleTheme = () => {
    setIsDark(prevState => {
      const newState = !prevState;
      if (newState) {
        document.body.classList.add('dark-mode');
        localStorage.setItem('theme', 'dark');
      } else {
        document.body.classList.remove('dark-mode');
        localStorage.setItem('theme', 'light');
      }
      return newState;
    });
  };

  const changeLanguage = (lng) => {
    setLanguage(lng);
  };

  return (
    <Router>
      <HighlightKeyword />
      <div className={`app ${theme}`}>
        <Navbar isDark={isDark} toggleTheme={toggleTheme} changeLanguage={changeLanguage} />
        <Chatbot isDark={isDark} toggleTheme={toggleTheme} changeLanguage={changeLanguage} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/About-rpx" element={<AboutRPX />} />
          <Route path="/achievements" element={<Achievements />} />
          <Route path="/social" element={<SocialLinks />} />
          <Route path="/drop" element={<Drop />} />
          <Route path="/pay" element={<UpiPayment />} />
          <Route path="/fixall" element={<DownloadList/>} />
          {/* Catch-all route for 404 errors */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;